/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Response serializer for marking management app as visited.
 */
export interface MarkManagementAppVisitedResponse { 
    /**
     * Indicates whether the teacher has visited the management app
     */
    hasVisitedManagementApp: boolean;
}